export default "__VITE_ASSET__863fccc5__"